/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorPayoutDetailConfig } from '../../config/error.config';

export interface IErrorPayoutDetailContentPluginMethods
  extends IPluginMethodMap {
  getErrorPayoutDetailContentSync(args?: any): any;
}

export class ErrorPayoutDetailContentPlugin implements IAgentPlugin {
  readonly methods: IErrorPayoutDetailContentPluginMethods;

  constructor() {
    this.methods = {
      getErrorPayoutDetailContentSync:
        this.getErrorPayoutDetailContentSync.bind(this),
    };
  }

  getErrorPayoutDetailContentSync(args?: any) {
    return {
      error: errorPayoutDetailConfig,
    };
  }
}
